import React from 'react';
import styled from 'styled-components';
import {
  Lease } from "../../services/IntegrationApi";
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';

interface Props {
  lease?: Lease,
}

const AccDebugTableContainer = styled(TableContainer)`
  background-color: rgba(0, 0, 0, 0.04);
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 42px;
  padding-right: 42px;
  border: dashed 1.25px rgba(0, 0, 0, 0.35);
  border-radius: 4px;
`;


const AccDebugTableTRHeader = styled(TableRow)`
  background-color: rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
`;

const AccDebugTableTRCell = styled(TableCell)`
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
`;

const AccDebugTableLeaseTRCell = styled(TableCell)`
  padding-left: 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
`;

export const AccDebugTableRow: React.FC<Props> = ({ lease }) => {
  return (
    <AccDebugTableContainer>
      <Table sx={{ minWidth: 485 }} aria-label="simple table">
        <TableBody>
          <TableRow>
            <AccDebugTableTRCell align="left" size='small'>First Name</AccDebugTableTRCell>
            <AccDebugTableTRCell align="left" size='small'>{lease?.firstName}</AccDebugTableTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableTRCell align="left" size='small'>Last Name</AccDebugTableTRCell>
            <AccDebugTableTRCell align="left" size='small'>{lease?.lastName}</AccDebugTableTRCell>
          </TableRow>
          <AccDebugTableTRHeader>
            <AccDebugTableTRCell align="left" size='small'>Leases</AccDebugTableTRCell>
            <AccDebugTableTRCell align="left" size='small'></AccDebugTableTRCell>
          </AccDebugTableTRHeader>
          
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Lease Number</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.leases[0].leaseNumber}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Original Lease Number</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.leases[0].originalLeaseNumber}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Lease Id</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.leases[0].leaseId}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Original Lease Id</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.leases[0].originalLeaseId}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Lease Status</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.leases[0].leaseStatus}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Lease Floor Plan</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.floorplan}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Roommate matching preference</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.roommateMatchingPreference}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Gender</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.gender}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Grouping</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.subnetwork}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Season Id</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.seasonId}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Lease Start date </AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.leases[0].leaseStartDate}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Lease End Date</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.leases[0].leaseEndDate}</AccDebugTableLeaseTRCell>
          </TableRow>
          <TableRow>
            <AccDebugTableLeaseTRCell align="left" size='small'>Lease Cancelled Date</AccDebugTableLeaseTRCell>
            <AccDebugTableLeaseTRCell align="left" size='small'>{lease?.leases[0].leaseCancelledDate}</AccDebugTableLeaseTRCell>
          </TableRow>
        </TableBody>
      </Table>
    </AccDebugTableContainer>
  );
};
